// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--k89TF";
export var header = "styles-module--header--+ep-0";
export var sidebar = "styles-module--sidebar--TtAMz";
export var blogLink = "styles-module--blog-link--0v76k";
export var share = "styles-module--share--tUoRq";
export var linkText = "styles-module--link-text--QH9ye";
export var keepReading = "styles-module--keep-reading--TYgqf";